import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

const EVENT_NOTIFICATION_ITEM_API_URL = `${API_HOST}/api/eventNotification`;

function* searchEvents() {
  yield takeEvery(actions.SEARCH_EVENTS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${EVENT_NOTIFICATION_ITEM_API_URL}/event?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_EVENTS_ENDED });
    }
  });
}

function* searchNotificationTools() {
  yield takeEvery(actions.SEARCH_NOTIFICATION_TOOLS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${EVENT_NOTIFICATION_ITEM_API_URL}/notificationTool?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_NOTIFICATION_TOOLS_ENDED });
    }
  });
}

function* searchEventAttributes() {
  yield takeEvery(actions.SEARCH_EVENT_ATTRIBUTES, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${EVENT_NOTIFICATION_ITEM_API_URL}/eventAttribute?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_EVENT_ATTRIBUTES_ENDED });
    }
  });
}

function* createEventNotification() {
  yield takeEvery(actions.CREATE_EVENT_NOTIFICATION, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], EVENT_NOTIFICATION_ITEM_API_URL, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.CREATE_EVENT_NOTIFICATION_ENDED });
    }
  });
}

function* searchEventNotifications() {
  yield takeEvery(actions.SEARCH_EVENT_NOTIFICATIONS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${EVENT_NOTIFICATION_ITEM_API_URL}?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_EVENT_NOTIFICATIONS_ENDED });
    }
  });
}

function* findEventNotification() {
  yield takeEvery(actions.FIND_EVENT_NOTIFICATION, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${EVENT_NOTIFICATION_ITEM_API_URL}/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.FIND_EVENT_NOTIFICATION_ENDED });
    }
  });
}

function* updateEventNotification() {
  yield takeEvery(actions.UPDATE_EVENT_NOTIFICATION, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], EVENT_NOTIFICATION_ITEM_API_URL, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_EVENT_NOTIFICATION_ENDED });
    }
  });
}

function* deleteEventNotifications() {
  yield takeEvery(actions.DELETE_EVENT_NOTIFICATIONS, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], `${EVENT_NOTIFICATION_ITEM_API_URL}`, {
        data,
      });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.DELETE_EVENT_NOTIFICATIONS_ENDED });
    }
  });
}

function* searchEventNotificationTasks() {
  yield takeEvery(actions.SEARCH_EVENT_NOTIFICATION_TASKS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${EVENT_NOTIFICATION_ITEM_API_URL}/task?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_EVENT_NOTIFICATION_TASKS_ENDED });
    }
  });
}

function* searchBrandStoreAccountEventNotificationTasks() {
  yield takeEvery(actions.SEARCH_BRAND_STORE_ACCOUNT_EVENT_NOTIFICATION_TASKS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${EVENT_NOTIFICATION_ITEM_API_URL}/brandStoreAccountTask?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_BRAND_STORE_ACCOUNT_EVENT_NOTIFICATION_TASKS_END });
    }
  });
}

function* unmaskEventNotificationContent() {
  yield takeEvery(actions.UNMASK_EVENT_NOTIFICATION_CONTENT, function* (action) {
    const { id, data, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'post'],
        `${EVENT_NOTIFICATION_ITEM_API_URL}/task/${id}/unmaskContent`,
        data,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UNMASK_EVENT_NOTIFICATION_CONTENT_ENDED });
    }
  });
}

function* searchNotificationConfigurations() {
  yield takeEvery(actions.SEARCH_NOTIFICATION_CONFIGURATIONS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${EVENT_NOTIFICATION_ITEM_API_URL}/configuration?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_NOTIFICATION_CONFIGURATIONS_ENDED });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(searchEvents),
    fork(searchNotificationTools),
    fork(searchEventAttributes),
    fork(createEventNotification),
    fork(searchEventNotifications),
    fork(findEventNotification),
    fork(updateEventNotification),
    fork(deleteEventNotifications),
    fork(searchEventNotificationTasks),
    fork(searchBrandStoreAccountEventNotificationTasks),
    fork(unmaskEventNotificationContent),
    fork(searchNotificationConfigurations),
  ]);
}
